export default function ({ store, redirect, route }) {
  if (
    !route.path.startsWith('/dashboard') &&
    !route.path.startsWith('/submissions')
  ) {
    return
  }

  if (route.path.startsWith('/dashboard')) {
    return redirect({
      path: '/scheduled',
      query: route.query,
      params: route.params
    })
  } else if (route.path.startsWith('/submissions')) {
    return redirect({
      path: '/history',
      query: route.query,
      params: route.params
    })
  }
}
